<template>
  <div class="px-0 col-md mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
    <h6 class="subtitulo mb-2">{{ labelTitle }}</h6>
    <div class="lineaNegra"></div>
    <div class="mt-1 mb-2 lineaNegra2"></div>
    <div class="card mt-4">
      <div class="card-body pt-1">
        <div class="row card-body">
          <div class="container mb-3">
            <span class="subtitulo2">
              <p class="m-0">{{ labelDescription }}</p>
            </span>
          </div>
          <div class="col-7">
            <select v-model="selectedOption" class="custom-select custom-select-sm" style="height:40px;">
              <option disabled>{{ placeholder }}</option>
              <option
                v-for="(option, index) in options"
                :key="index"
                :value="option"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div v-if="showButton" class="col-5">
            <button @click="onSelect" class="btn btn-vino btn-block">{{ buttonText }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- <h5 v-if="optionToShow" class="subtitulo2 mt-5">{{ resultTitle }} {{ optionToShow.label }}</h5> -->
    <div v-if="optionToShow">
      <!-- <p><strong>Valor:</strong> {{ optionToShow.value }}</p> -->
    </div>

    <div v-show="loading && optionToShow">
      <!-- <spinner></spinner> -->
      <h6 class="text-center text-muted mb-5">{{ loadingText }}</h6>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    labelTitle: {
      type: String,
      default: "Seleccione una opción"
    },
    labelDescription: {
      type: String,
      default: "Por favor, seleccione una opción de la lista"
    },
    placeholder: {
      type: String,
      default: "Seleccionar opción"
    },
    buttonText: {
      type: String,
      default: "Consultar"
    },
    resultTitle: {
      type: String,
      default: "Resultado para"
    },
    loadingText: {
      type: String,
      default: "Cargando contenido..."
    },
    loading: {
      type: Boolean,
      default: false
    },
    optionToShow: {
      type: Object,
      default: null
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedOption: null
    };
  },
  methods: {
    onSelect() {
      if (this.selectedOption) {
        // Emitir el objeto completo en lugar de solo el valor
        this.$emit('optionSelected', this.selectedOption);
      }
    }
  }
};
</script>

<style scoped>
@media only screen and (max-device-width : 420px){
 .btn{
  font-size: 11px;
 }
}
</style>
